import React from 'react';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DASHBOARD_COLORS } from './dashboardStyles';
import InsightAiAssistantButton from './ai/InsightAiAssistantButton';

const SummaryCard = ({
  label,
  value,
  accentColor,
  icon: Icon,
  trend,
  loading,
  onClick,
  showAiAssistant,
  onAiAssistantClick,
}) => (
  <Paper
    elevation={0}
    onClick={!loading && onClick ? onClick : undefined}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick && !loading ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
    sx={{
      p: 1.75,
      height: '100%',
      minHeight: 108,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      borderRadius: 2,
      bgcolor: DASHBOARD_COLORS.surface,
      border: `1px solid ${DASHBOARD_COLORS.border}`,
      borderLeft: `4px solid ${accentColor}`,
      cursor: onClick && !loading ? 'pointer' : 'default',
      position: 'relative',
      overflow: 'hidden',
      transition: 'box-shadow 0.2s ease, transform 0.15s ease',
      '&:hover': onClick
        ? {
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            transform: 'translateY(-2px)',
          }
        : {},
      '&::after': {
        content: '""',
        position: 'absolute',
        right: -20,
        bottom: -20,
        width: 72,
        height: 72,
        borderRadius: '50%',
        bgcolor: `${accentColor}0c`,
        pointerEvents: 'none',
      },
    }}
  >
    {loading ? (
      <Box flex={1} display="flex" alignItems="center" justifyContent="center" minHeight={72}>
        <CircularProgress size={24} sx={{ color: accentColor }} />
      </Box>
    ) : (
      <>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1}>
          <Box flex={1} minWidth={0}>
            <Typography
              sx={{
                fontWeight: 700,
                color: DASHBOARD_COLORS.text,
                fontSize: { xs: '1.1rem', sm: '1.25rem' },
                lineHeight: 1.2,
                mb: 0.35,
              }}
            >
              {value}
            </Typography>
            <Typography variant="body2" sx={{ color: DASHBOARD_COLORS.textMuted, fontWeight: 500, lineHeight: 1.3 }}>
              {label}
            </Typography>
          </Box>
          {Icon && (
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1.5,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: `${accentColor}14`,
                color: accentColor,
              }}
            >
              <Icon sx={{ fontSize: 22 }} />
            </Box>
          )}
        </Box>

        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1} gap={0.5}>
          {trend?.text ? (
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: trend.positive === false ? DASHBOARD_COLORS.danger : accentColor,
              }}
            >
              {trend.text}
            </Typography>
          ) : (
            <Box flex={1} />
          )}
          <Box display="flex" alignItems="center" gap={0.5} ml="auto">
            {showAiAssistant && onAiAssistantClick && (
              <InsightAiAssistantButton onClick={onAiAssistantClick} />
            )}
            {onClick && (
              <ArrowForwardIosIcon sx={{ fontSize: 12, color: DASHBOARD_COLORS.textMuted, opacity: 0.6 }} />
            )}
          </Box>
        </Box>
      </>
    )}
  </Paper>
);

export default SummaryCard;
